module.exports = __webpack_public_path__ + "img/empty_image.0f654606.jpg";